import { logger } from '@/lib/default-logger';
import { Bug } from '@phosphor-icons/react';
import _ from "lodash";


let authErrorState = false;

// export function setAuthErrorState(state) {
//   authErrorState = state;
//   // if (state) {
//   //   dispatchAuthError();
//   // }
// }

export function getAuthErrorState() {
  return authErrorState;
}

async function fetchDataFromEndpoint(endpoint) {
  // logger.debug("get projs", endpoint);

    try {
        const response = await fetch(endpoint);
        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
          logger.error(
            'fetchAPIData error response status:',
            response.status,
            response.statusText,
            endpoint
          );
          const errorText = await response.text();
          logger.error('fetchAPIData error response text:', errorText);
    
          if (
            response.status === 401 ||
            response.status === 403 ||
            errorText.includes('Invalid or expired authToken')
          ) {
            
            
            localStorage.setItem("sessionTimedout", true)
            window.location.reload();
            logger.warn(
              'fetchAPIData: Auth error detected, emitting authError event...'
            );
          }
          return null;
        }
        
    } catch (error) {
        logger.error('Error fetching data:', error);
        return null;
    }
}


async function fetchAPIData(baseURL, expr, shouldEncodeURL = true) {
  localStorage.removeItem("sessionTimedout", true)
  logger.debug('fetchAPIData start', baseURL, expr, shouldEncodeURL);
  let url;
  if (shouldEncodeURL) {
    const encodedExpr = encodeURIComponent(expr).replace(
      /['()*]/g,
      (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`
    );
    url = baseURL + encodedExpr;
  } else {
    url = baseURL + expr;
  }

  logger.debug('fetchAPIData url:', url, expr);

  try {
    const token = localStorage.getItem('token');
  // logger.debug('fetchAPIData token:', token);

    const response = await fetch('/api/fetchData', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        url: url,
        token: token,
      }),
    });

    logger.debug('fetchAPIData response', response.status, response, expr);

    if (response.ok) {
      const contentType = response.headers.get('content-type');
    // logger.debug('fetchAPIData content type:', contentType);

      if (contentType.includes('application/json')) {
        const data = await response.json();
      // logger.debug('fetchAPIData JSON data received');
        return data;
      } else if (contentType.includes('image')) {
        const arrayBuffer = await response.arrayBuffer();
        const base64Image = btoa(
          new Uint8Array(arrayBuffer).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ''
          )
        );
      // logger.debug('fetchAPIData received image (base64)');
        return base64Image;
      } else {
        const text = await response.text();
      // logger.debug('fetchAPIData received text:', text);
        return text;
      }
    } else {
      logger.error(
        'fetchAPIData error response status:',
        response.status,
        response.statusText,
        url
      );
      const errorText = await response.text();
      logger.error('fetchAPIData error response text:', errorText);

      if (
        response.status === 401 ||
        response.status === 403 ||
        errorText.includes('Invalid or expired authToken')
      ) {
        
        localStorage.setItem("sessionTimedout", true)
        window.location.reload();
        logger.warn(
          'fetchAPIData: Auth error detected, emitting authError event...'
        );
      }
      return null;
    }
  } catch (error) {
    logger.error('fetchAPIData error:', error.message, url);
    if (
      error.message.includes('Failed to fetch') ||
      error.message.includes('Network error')
    ) {
      logger.warn(
        'fetchAPIData: Possible network error, might be due to auth issues. Emitting authError event...'
      );
      CustomeventEmitter.dispatch('authError');
    }
    return null;
  }
}


async function fetchExprData(currentProject, selectedViewParams, expr) {
  logger.debug('fetch, selected params', selectedViewParams, expr)
  const parsedProject = currentProject.id.replace('p:', '');
  const url = `https://data.clistek.io/api/${parsedProject}/eval?expr=`;
  
  logger.debug('replace params: fetch expr data', selectedViewParams)
  let newExpr = replaceParams(expr, selectedViewParams);
  logger.debug('replace final', newExpr)
  logger.debug('expr url', url, selectedViewParams, expr, newExpr);

  const data = await fetchAPIData(url, newExpr, true);
  logger.debug('api data', newExpr, data)

  if (data) {
    return data;
  } else return null;
}

const fetchTooltip = async(currentProject, selectedViewParams, config) => {
  if (!config.tooltip) return null;

  if (config.tooltip.dataSource.type === "text") {
      return config.tooltip.dataSource.text;
  } else if (config.tooltip.dataSource.type === "apiExpr") {
     let data = await fetchExprData(currentProject, selectedViewParams, config.tooltip.dataSource.expr);

      if (data?.rows && data.rows.length > 0) {
          let val = data.rows[0].val;
          if (val) return val;
      }
  }

  return null;
}   

const replaceParams = (expr, params) => {
  logger.debug('replace start', expr, params)
  let result = expr;
  for (const paramKey in params) {
    logger.debug('replace cur param', paramKey, params[paramKey]);
    let param = params[paramKey];
    if (!param.value) continue;

    let target = `{{${paramKey}}}`;
    let targetRegex = new RegExp(target, "g");
    let replacement = param.value;
    logger.debug('replace processed param', target, replacement, param, expr);

    if (param.kind) { // add extra formatting as needed
      switch(param.kind.toLowerCase()) {
        case "ref":
          replacement = "@" + param.value;
          break;
        case "str":
          if (param.type === "dateSpan" || param.name === "span") {
            // logger.debug('span detected true', param)
            replacement = param.dis.toLowerCase() === "range" ? param.value : `\"${param.value}\"`;
          } else {
            // logger.debug('span detected false', param)
            replacement = `\"${param.dis}\"`
          }
          break;
        case "ref[]":
          // let refList = param.value.map((item) => {
          //   logger.debug('cur val:', item)
          //   let val = ''
          //   if (typeof item === "object" && item.value) {
          //     val = item.value;
          //   } else val = item;
          //   return val.startsWith("@") ? val : "@" + val
          // })
          let refList = '';
          logger.debug('replace arr detected', param.value, Array.isArray(param.value))
          if (!Array.isArray(param.value)) break
          for (const item of param.value) {
            let val = ''
            logger.debug('replace cur item', item)
            if (typeof item === "object" && item.value) {
              val = item.value;
            } else val = item;
              val = val.startsWith("@") ? val : "@" + val;
              refList += `${val},`
          }
          refList = refList.slice(0, -1);
          replacement = `[${refList}]`;
          logger.debug('ref list', refList, replacement);
          break;
        case "str[]":
          let strList = param.value.map((item) => `\"${item}\"`);
          replacement = `[${strList}]`;
          break;
      }
    }

    result = result.replace(targetRegex, replacement);
    logger.debug('replace cur match', targetRegex, replacement, result);
  }

  logger.debug('replace end', result, expr, params)
  return result;

}

/**
 * Given a data source, extracts the params from its expression
 * e.g. input: myFunc({{paramA}},{{paramB}}) -> output: ["paramA", "paramB"]
 * These are called tracked params bc the object that the expr belogns to depends on these params to make api calls and get data
 * We wanna refetch the object's data whenever its tracked params change
 * @param {Object || String} dataSource Object {type: "apiExpr", expr: "myExpr"} when called by a view object (e.g. Gauge), is a string when called by a param (e.g. Tree) -> See json view definitions for how they differ
 * @param {*} params 
 * @returns 
 */
const extractTrackedParams = (dataSource) => { 
  logger.debug('extract track start', dataSource, typeof dataSource)
  if (!dataSource) return [];
  let expr = '';
  if (typeof dataSource === "object") {
    if (!dataSource.type === "apiExpr" || !dataSource.expr) return [];
    expr = dataSource.expr;
  } else if (typeof dataSource === "string") {
    expr = dataSource;
  } else return [];

  logger.debug('extract track expr', expr);

  // previously, params were all selected at once
  // now that they can be selected in phases (e.g. dropdown -> marker),
  // try extracting the tracked params from the expr itself, this way we also only need to do this once
  let foundParams = expr.match(/{{[a-zA-Z]*}}/g)?.map((val) => val.replace(/{{|}}/g, '')) || [];
  logger.debug('found params', foundParams);
  return foundParams;
}

/**
 * Compares the changed params to the tracked params to determine if any tracked params changed. Then, compares the new param values against the old params to determine if any values changed
 * @param {Array} trackedParamNames 
 * @param {Array} changedParamNames 
 * @param {Object} newParams selectedViewParams
 * @param {Object} oldParamRef trackedParamsRef
 * @returns 
 */
const extractChangedParams = (trackedParamNames=[], changedParamNames=[], newParams={}, oldParamRef={}) => {
  let changedTrackedParamNames = changedParamNames?.filter(value => trackedParamNames?.includes(value));
  let changedParams = {
    changed: false,
    paramRef: oldParamRef ?? {}
  };

  for (const param of changedTrackedParamNames) {
    logger.debug('cur changed param', param, newParams[param], oldParamRef[param])
    if (Array.isArray(newParams[param])) {
      const newArr = newParams[param] ?? [];
      const oldArr = oldParamRef[param] ?? [];
      // const symmetricDiff = _.xor(oldArr, newArr, 'value'); // find if the arrays have any differing vals (a val is in 1 arr but not he other)
      const symmetricDiff = _.xorBy(oldArr, newArr, 'value'); // find if the arrays have any differing vals (a val is in 1 arr but not he other)
      logger.debug("changed array", symmetricDiff, newParams[param], newArr);
      if (symmetricDiff.length > 0) {
        changedParams.changed = true;
        changedParams.paramRef[param] = newArr;
      }
      
    } else {
      if (newParams[param]?.value !== oldParamRef[param]) {
      changedParams.changed = true;
      changedParams.paramRef[param] = newParams[param].value;
    }
    }
  };

  return changedParams;

}

export { 
  fetchDataFromEndpoint, 
  fetchAPIData, 
  fetchExprData, 
  fetchTooltip, 
  replaceParams,
  extractTrackedParams,
  extractChangedParams,
  // getAuthErrorState,
  // setAuthErrorState
};